import { render, staticRenderFns } from "./MultiModel.vue?vue&type=template&id=2d1966a6&"
import script from "./MultiModel.vue?vue&type=script&lang=js&"
export * from "./MultiModel.vue?vue&type=script&lang=js&"
import style0 from "./MultiModel.vue?vue&type=style&index=0&id=2d1966a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports